import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Timeline/Timeline.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/timeline/react/latest'} mdxType="DeprecationBanner" />
    <p>{`The Timeline.Item component is used to display items on a vertical timeline, connected by Timeline.Badge elements.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Example with in-line links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item>
    <Timeline.Badge>
      <Octicon icon={FlameIcon} />
    </Timeline.Badge>
    <Timeline.Body>
      <Link href="#" sx={{fontWeight: 'bold', color: 'fg.default', mr: 1}} muted>
        Monalisa
      </Link>
      created one <Link href="#" sx={{fontWeight: 'bold', color: 'fg.default', mr: 1}} muted>
        hot potato
      </Link>
      <Link href="#" color="fg.muted" muted>
        Just now
      </Link>
    </Timeline.Body>
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h3>{`Default Color example`}</h3>
    <p>{`The default Timeline.Badge color is dark text on a light grey background.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item>
    <Timeline.Badge>
      <Octicon icon={FlameIcon} />
    </Timeline.Badge>
    <Timeline.Body>Default badge color</Timeline.Body>
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h3>{`Adding color to a Badge`}</h3>
    <p>{`To have color variants, use the `}<inlineCode parentName="p">{`bg`}</inlineCode>{` prop on the `}<inlineCode parentName="p">{`Timeline.Badge`}</inlineCode>{`. If an icon is being used, set the `}<inlineCode parentName="p">{`color`}</inlineCode>{` prop
of the child `}<inlineCode parentName="p">{`Octicon`}</inlineCode>{` if necessary.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item>
    <Timeline.Badge sx={{bg: 'danger.emphasis'}}>
      <Octicon icon={FlameIcon} sx={{color: 'fg.onEmphasis'}} />
    </Timeline.Badge>
    <Timeline.Body>Background used when closed events occur</Timeline.Body>
  </Timeline.Item>
  <Timeline.Item>
    <Timeline.Badge sx={{bg: 'danger.emphasis'}}>
      <Octicon icon={FlameIcon} color="fg.onEmphasis" />
    </Timeline.Badge>
    <Timeline.Body>Background when opened or passed events occur</Timeline.Body>
  </Timeline.Item>
  <Timeline.Item>
    <Timeline.Badge sx={{bg: 'danger.emphasis'}}>
      <Octicon icon={FlameIcon} sx={{color: 'fg.onEmphasis'}} />
    </Timeline.Badge>
    <Timeline.Body>Background used when pull requests are merged</Timeline.Body>
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h3>{`Condensed items`}</h3>
    <p>{`Timeline has a condensed prop that will reduce the vertical padding and remove the background from the badge item. These are most commonly used in commits. To condense a single item, remove the top or bottom padding with the `}<inlineCode parentName="p">{`pt={0}`}</inlineCode>{` or `}<inlineCode parentName="p">{`pb={0}`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item condensed>
    <Timeline.Badge>
      <Octicon icon={GitCommitIcon} />
    </Timeline.Badge>
    <Timeline.Body>This is the message of a condensed TimelineItem</Timeline.Body>
  </Timeline.Item>
  <Timeline.Item condensed>
    <Timeline.Badge>
      <Octicon icon={GitCommitIcon} />
    </Timeline.Badge>
    <Timeline.Body>This is the message of a condensed TimelineItem</Timeline.Body>
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h3>{`Timeline Break`}</h3>
    <p>{`To create a visual break in the timeline, use Timeline.Break. This adds a horizontal bar across the timeline to show that something has disrupted it. Usually this happens when a close or merged event occurs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item>
    <Timeline.Badge sx={{bg: 'danger.emphasis'}}>
      <Octicon icon={FlameIcon} color="fg.onEmphasis" />
    </Timeline.Badge>
    <Timeline.Body>Background used when closed events occur</Timeline.Body>
  </Timeline.Item>
  <Timeline.Break />
  <Timeline.Item>
    <Timeline.Badge sx={{bg: 'success.emphasis'}}>
      <Octicon icon={FlameIcon} sx={{color: 'fg.onEmphasis'}} />
    </Timeline.Badge>
    <Timeline.Body>Background when opened or passed events occur</Timeline.Body>
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      